import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { InfestationType } from "../types/service";

export type MonitorSliceState = {
  monitorPosition: MonitorPosition;
  position: string | number;
  pinName: string;
  location: string;
  isWireless: boolean;
  wirelessId: string | null;
  trapType: InfestationType;
};

type MonitorPosition = {
  x: number;
  y: number;
};

const initialState: MonitorSliceState = {
  monitorPosition: {
    x: 1,
    y: 1,
  },
  position: "",
  pinName: "",
  location: "",
  isWireless: false,
  wirelessId: null,
  trapType: "baitEaten",
};

export const adjustPinSlice = createSlice({
  name: "adjustPin",
  initialState: initialState,
  reducers: {
    setMonitorPosition(state, { payload }: PayloadAction<MonitorPosition>) {
      state.monitorPosition = payload;
    },
    setPosition(state, { payload }: PayloadAction<string | number>) {
      state.position = payload;
    },
    setPinName(state, { payload }: PayloadAction<string>) {
      state.pinName = payload;
    },
    setLocation(state, { payload }: PayloadAction<string>) {
      state.location = payload;
    },
    setIsWireless(state, action: PayloadAction<boolean>) {
      state.isWireless = action.payload;
    },
    setWirelessId(
      state,
      { payload }: PayloadAction<{ wirelessId: string | null }>
    ) {
      state.wirelessId = payload.wirelessId;
    },
    setTrapType(state, action: PayloadAction<InfestationType>) {
      state.trapType = action.payload;
    },
    resetState(state) {
      return {
        ...initialState,
      };
    },
  },
});

export const adjustPinActions = adjustPinSlice.actions;
